<template>
    <div class='drug-config-pannel'>
      <div class="params-header">
          <div class="modal-actions">
              <div class="tokens-info">
                  <div class="tokens-icon"></div>
                  <div v-if="computedTokens">{{computedTokens}} {{$t('compute_tokens')}}</div>
                  <div v-else>Loading...</div>
              </div>
              <div class="btn btn--primary" @click="doSave" v-tooltip="error">Generate Trials</div>
          </div>
      </div>
      <div class="config-blocks">
        <div class="left-block drug-params">
          <div class="section-title" :style="{margin: '0 0 10px 10px'}">Drug Parameters</div>
          <div class="drug-params">
            <generic-input-container
              v-model="drugName"
            ></generic-input-container>
            <generic-input-container
              v-model="concentrationsUnits"
              v-on:child-event="convertConcentrationUnits()"
            ></generic-input-container>
          </div>
          <div>
            <generic-input-container
              v-model="molecularWeight"
              :showUnits="true"
            ></generic-input-container>
          </div>
          <div class="drug-dynamic-container">
            <div class="input-group item">
              <label class="input-label">Total Concentrations<span class="field-info" v-tooltip="'Plasma concentrations to be tested'"></span></label>
              <div class="dynamic-input-wrapper" v-for="(dose,i) in concentrations" :key="i">
                <generic-input-container class="input-box" v-model="concentrations[i]" :key="i" :showLabel="false" :showTooltip="false"/>
                <div class="delete-button" :class="{disabled: concentrations.length == 2}" @click="onRemoveDose(dose)"></div> 
              </div>
              <div v-if="this.concentrations.length < 7" class="add-button" @click="onAddDose">+ Add dose</div>
              <div v-else class="no-more-add" >Max 7 doses</div>
            </div>
            <div class="input-group item">
              <label class="input-label">Free fraction in percent<span class="field-info" v-tooltip="'Free Percentage Protein Binding values to be tested'"></span></label>
              <div class="dynamic-input-wrapper" v-for="(fppb,i) in fppbs" :key="i">
                <generic-input-container class="input-box" v-model="fppbs[i]" :key="i" :showLabel="false" :showTooltip="false"/>
                <div class="delete-button" :class="{disabled: fppbs.length == 1}" @click="onRemoveFppb(fppb)"></div> 
              </div>
              <div v-if="this.fppbs.length < 7" class="add-button disabled" @click="onAddFppb">+ Add percentage</div>
              <div v-else class="no-more-add" >Max 7 FPPBs</div>
            </div>
          </div>
        </div>
        <div class="left-block ion-channels">
          <div class="plot-container">
              <div class="custom-drug-validation-plot">
              <div class="section-title">Validation Curve</div>
                <custom-drug-validation-plot class="section-content"
                  :isEditing="true"
                  :channels="channels"
                  :hValues="hValues"
                  :ic50Values="ic50Values"
                  :concentrations="concentrationValues"
                  :concentrationUnits="concentrationsUnits.value"
                  :molecularWeight="molecularWeight.value"
                  :height="450"
                  :width="650"
                ></custom-drug-validation-plot>
            </div>
            <div class="ion-channels-container">
              <div class="section-title">Channels</div>
              <table class="channels-container">
                <tbody>
                  <tr class="channels-labels">
                    <td></td>
                    <td class="param" v-for="(channelName,i) in channels.names" :key="i">
                      <div class="channel-label">
                        {{ channelName }}
                        <hr :style="{ backgroundColor: channelColors[i], height: '3px', width: '70%', borderWidth: 0 }">
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="parameter-label">IC50 (nmol/L)</td>
                    <td class="param" v-for="(channelName,i) in channels.names" :key="i">
                      <generic-input-container class="input-box" v-model="channels.ic50[i]" :showLabel="false" :showTooltip="false"/>
                    </td>
                  </tr>
                  <tr>
                    <td class="parameter-label">H</td>
                    <td class="param" v-for="(channel,i) in channels.names" :key="channel">
                      <generic-input-container class="input-box" v-model="channels.h[i]" :showLabel="false" :showTooltip="false"/>
                    </td>
                  </tr>
                </tbody> 
              </table>
            </div>
          </div>
        </div>
        <div class="right-block">
          <label class="section-title">Population Parameters<span class="field-info"></span></label>
          <div class="params-container">
            <div class="pupulation-column">
              <generic-input-container class="population-box"
                v-model="popSelectorName"
                :showLabel="true"
              ></generic-input-container>
            </div>
            <div class="size-column">
              <label class="input-label">Population size<span class="field-info" v-tooltip="'Amount of subjects per trial'"></span></label>
              <generic-input-container class="size-box"
                v-model="popSelectorPopSize"
              ></generic-input-container>
            </div>
            <div class="description-column">
              <label class="input-label">Information<span class="field-info" v-tooltip="'Population female ratio and original mesh information'"></span></label>
              <div class="description-box">
                <div class="descriptors">
                    <div class="item" v-for="descriptor in populationDescriptors"> {{  descriptor }}</div>
                </div>
                <div class="infos">
                    <div class="item" v-for="info,i in populationsInfo[selectedPopulation]">{{ info }}</div>
                </div>
              </div>
            </div>
            <!-- <generic-input-container class="item"
              v-model="subjects"
            ></generic-input-container>
            <generic-input-container class="item"
              v-model="femaleRatio"
            ></generic-input-container> -->
          </div>
          <div class="scenario-container">
            <div class="input-group item">
              <label class="input-label">Heart Rate<span class="field-info" v-tooltip="'Heart rates to be tested'"></span></label>
              <div class="dynamic-input-wrapper" v-for="(heartRate,i) in heartRates" :key="i">
                <generic-input-container class="input-box disabled" v-model="heartRates[i]" :key="i" :showLabel="false" :showTooltip="false"/>
                <div class="delete-button" :class="{disabled: heartRates.length == 1}" @click="onRemoveHeartRate(heartRate)"></div> 
              </div>
              <div v-if="this.heartRates.length < 7" class="add-button disabled" @click="onAddHeartRate">+ Add heart rate</div>
              <div v-else class="no-more-add" >Max 7 heart rates</div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import InputContainer from '@/components/inputs/InputContainer'
import IonChannels from '@/components/inputs/IonChannels'
import CustomDrugValidationPlot from '@/components/trial/CustomDrugValidationPlot'
import SubFieldListInputContainer from '@/components/inputs/SubFieldListInputContainer'
import DynamicInputGroup from '@/components/inputs/DynamicInputGroup'
import GenericInputContainer from '@/components/inputs/frontendInputs/GenericInputContainer'
import PopulationSelectorComponent from '@/components/trial/PopulationSelectorComponent'
import ToggleInput from '@/components/inputs/inputsTypes/ToggleInput'
import d3 from '@/utils/d3importer'
import Api from '@/api'
import { convertUnits, unit_nGmL, unit_nML, destinationUnit } from '@/utils/UnitConverer'


export default {
  name: 'CustomDrugTrialsConfiguration',
  components: { InputContainer, IonChannels, CustomDrugValidationPlot, PopulationSelectorComponent, SubFieldListInputContainer, DynamicInputGroup, GenericInputContainer, ToggleInput },
  props: [
    'computeTokens'
  ],
  data() {
    return {
      error: '',
      populationDescriptors : ['Phenotype', 'Female ratio', 'Mesh count', 'BMI class.',   'Scar'],
      populationsInfo: {
        'T1.0': ['Healthy', '0.5', '1', 'Underweight',  'No'],
        'T1.1': ['Healthy', '0.5', '1', 'Normal', 'No']
      },
      drugName: {
        label: 'Drug Name',
        description: 'Name of the drug to be tested',
        valueType: 'string',
        value: 'Test Drug',
        view: {
          inputType: 'field',
          isFrontend: true
        }
      },
      fppbs: [
        {
          value: 10,
          valueType: 'decimal',
          view: {
            inputType: 'field',
            isFrontend: true,
            units: '%',
            validate_min: [0],
            validate_max: [100]
          }
        }
      ],
      heartRates: [
        {
          value: 60,
          valueType: 'decimal',
          view: {
            inputType: 'field',
            isFrontend: true,
            units: 'bpm',
            validate_min: [0]
          }
        }
      ],
      concentrationsUnits: {
        label: 'Concentration units',
        description: 'Units of molecular weight concentrations',
        valueType: 'string',
        value: unit_nGmL,
        view: {
          name: 'Population Size',
          inputType: 'toggle',
          validate_items: [unit_nGmL, unit_nML],
          isFrontend: true,
        }
      },
      molecularWeight: {
        label: 'Molecular Weight',
        description: 'Molecular weight of the drug',
        valueType: 'decimal',
        value: 50,
        view: {
          inputType: 'field',
          units: 'g/mol',
          validate_min: [0],
          isFrontend: true
        }
      },
      popSelectorName: 
        {
          label: 'Population Name',
          description: 'Select a population to display its configuration',
          valueType: 'string',
          value: 'T1.0',
          view: {
            inputType: 'select',
            validate_items: [
              "T1.0",
              "T1.1"
            ],
            isFrontend: true,
          }
      },
      popSelectorPopSize: {
        valueType: 'integer',
        value: 16,
        view: {
          name: 'Population Size',
          inputType: 'toggle',
          validate_items: [16,32,64],
          isFrontend: true,
        }
      },
      concentrations: [
        {
          value: 10,
          valueType: 'decimal',
          view: {
            inputType: 'field',
            isFrontend: true,
            units: 'ng/mL',
            validate_min: [0]
          }
        },
        {
          value: 100,
          valueType: 'decimal',
          view: {
            inputType: 'field',
            isFrontend: true,
            units: 'ng/mL',
            validate_min: [0]
          }
        },
        {
          value: 300,
          valueType: 'decimal',
          view: {
            inputType: 'field',
            isFrontend: true,
            units: 'ng/mL',
            validate_min: [0]
          }
        }
      ],
      channels: {
        names: ['Cav1.2', 'hERG', 'Kir2.1', 'Kv4.3', 'KvLQT1/minK', 'Nav1.5-late', 'Nav1.5-peak'],
        ic50: [
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          }
        ],
        h: [
        {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          },
          {
          valueType: 'decimal',
          value: 0,
            view: {
              inputType: "field",
              isFrontend: true,
              validate_min: [0]
            }
          }
        ],
      }
    }
  },
  computed: {
    concentrationValues() {
      return this.concentrations.map(dose => dose.value)
    },
    ic50Values() {
      return this.channels.ic50.map(channel => channel.value)
    },
    hValues() {
      return this.channels.h.map(channel => channel.value)
    },
    channelColors() {
        let indices = Array.from(this.channels.names.keys())
        return indices.map(i => d3.schemePaired[i])
    },
    selectedPopulation() {
        return this.popSelectorName.value
    },
  },
  asyncComputed: {
    async computedTokens() {
      let jsonConfig = JSON.parse(JSON.stringify(await this.jsonDrugConfig()))
      return Api.getTrialSetTokens(jsonConfig).then(response => response)
    }
  },
  methods: {
    convertConcentrationUnits(){
      this.concentrations.forEach(element => {
        const newUnit = this.concentrationsUnits.value;
        const lastUnit = newUnit == unit_nGmL ? unit_nML : unit_nGmL;
        element.value = convertUnits(
          element.value,
          this.molecularWeight.value,
          lastUnit,
          newUnit
        );
        element.view.units = newUnit;
        // element.view.units = this.concentrationsUnits.value;
      });
    },
    onAddDose(){
      let newDose = JSON.parse(JSON.stringify(this.concentrations[0]))
      newDose.value = 0
      this.concentrations.push(newDose)
    },
    onRemoveDose(removeThis){
      let indexToRemove = this.concentrations.findIndex(dose => dose == removeThis)
      this.concentrations.splice(indexToRemove,1)
    },
    onAddFppb(){
      let newFppb = JSON.parse(JSON.stringify(this.fppbs[0]))
      newFppb.value = 0
      this.fppbs.push(newFppb)
    },
    onRemoveFppb(removeThis){
      let indexToRemove = this.fppbs.findIndex(fppb => fppb == removeThis)
      this.fppbs.splice(indexToRemove,1)
    },
    onAddHeartRate(){
      let newHeartRate = JSON.parse(JSON.stringify(this.heartRates[0]))
      newHeartRate.value = 75
      this.heartRates.push(newHeartRate)
    },
    onRemoveHeartRate(removeThis){
      let indexToRemove = this.heartRates.findIndex(heartRate => heartRate == removeThis)
      this.heartRates.splice(indexToRemove,1)
    },
    async doSave(){
      let jsonConfig = JSON.parse(JSON.stringify(await this.jsonDrugConfig()))
      return Api.postTrialSet(jsonConfig)
        .then(this.$router.replace(`/project/${this.$store.state.paramsData.project.id}`))
    },
    async jsonDrugConfig() {
        return {
            "project_id": this.$store.state.paramsData.project.id,
            "cardiac_cycles": this.heartRates.map(heartRate => 60 / heartRate.value),
            "duration": 10, // Setting 10s run_duration as it is the default set for single trials in the backend. TODO (backend): trial_run_duration = cycle_length * cardiac_cycles
            "population_name": this.popSelectorName.value.toString(),
            "pop_size": this.popSelectorPopSize.value,
            "trial_set": {
                "trial_type": "ITQT",
                "drug_name": this.drugName.value,
                "molecular_weight": this.molecularWeight.value,
                "ppbs": this.fppbs.map(ppb => ppb.value),
                "ic50": {
                  "Cav1_2": this.channels.ic50[0].value,
                  "hERG": this.channels.ic50[1].value,
                  "Kir2_1": this.channels.ic50[2].value,
                  "Kv4_3": this.channels.ic50[3].value,
                  "KvLQT1_minK": this.channels.ic50[4].value,
                  "Nav1_5_late": this.channels.ic50[5].value,
                  "Nav1_5_peak": this.channels.ic50[6].value
                },
                "h": {
                  "Cav1_2": this.channels.h[0].value,
                  "hERG": this.channels.h[1].value,
                  "Kir2_1": this.channels.h[2].value,
                  "Kv4_3": this.channels.h[3].value,
                  "KvLQT1_minK": this.channels.h[4].value,
                  "Nav1_5_late": this.channels.h[5].value,
                  "Nav1_5_peak": this.channels.h[6].value
                },
                // Convert each concentration value to the one that backend knows, which is destinationUnit="ng/mL"
                "concentrations": this.concentrations.map(concentration => convertUnits(
                                                                            concentration.value, 
                                                                            this.molecularWeight.value,
                                                                            concentration.view.units,
                                                                            destinationUnit)
                                                          ),
            }
        }
    },
  },
}
</script>

<style lang="stylus" scoped>
.drug-config-pannel
  display: flex
  flex-direction: column

  .params-header
        display: flex
        margin: 10px 30px
        .modal-actions
            margin-left: auto
            align-items: center
            display flex
            max-height 32px
        .tokens-info
            margin-right: 15px
            display: flex
            flex-direction: row
            m-font-size(14,16)
            .tokens-icon
                m-icon("tokens", 18)
                margin-right 5px

  .config-blocks
    display: flex
    overflow: auto
    padding: 0 30px 0 30px
    justify-content: space-between
    .input-label
      color: $shuttle-gray
      display: flex
      align-items: center
      m-font-size(12, 14)
      margin-bottom: 5px
      .field-info
        margin-left: 5px
        m-icon('info', 14)

    .input-box
      margin-bottom: 5px
      &.disabled
        opacity: 0.4
        pointer-events: none
    .input-group
      overflow-y: auto

      .dynamic-input-wrapper
        margin-right: 3px
        margin-bottom: 10px
        border 2px solid  #f0f0f6
        border-radius 3px
        background  #f0f0f6
        box-shadow 0 0 10px rgba($lynch, 0.25)
        display: flex
        direction: column
        &.simple
          background: transparent
          box-shadow: none
          margin-bottom: 0px
        .delete-button
          align-self: top
          margin-top: 10px
          justify-content: left
          m-icon("cross", 20)
          flex: 0 0 20px; 
          cursor: pointer
          margin-right: 10px
          &.disabled
            opacity: 0.4
            pointer-events: none
      .add-button
        margin: 0 10px 10px 10px
        background: rgba(255, 255, 255, 0.5)
        border: 1px solid $cloud-burst
        border-radius: 20px
        color: $cloud-burst
        cursor: pointer
        max-width: 150px
        padding: 7px
        text-align: center

        &:hover
          background: rgba(255, 255, 255, 0.9)
        &.disabled
            opacity: 0.4
            pointer-events: none

      .no-more-add
        margin: 10px 10px
        color $storm-gray
        opacity 0.5

    .section-title
      m-font-size(16, 18)
      color: $gull-gray
      font-weight: $fw-light
      text-transform: uppercase

    .right-block
      display: flex
      flex: 1 1 25%
      flex-direction: column
      overflow: auto
      margin-left: 15px

      .params-container
        background  #f0f0f6
        box-shadow 0 0 10px rgba($lynch, 0.25)
        border-radius: 4px
        margin: 15px 0 15px 0
        display: flex
        padding-top: 5px
        justify-content: space-between

        .description-column
            width: 30%
            padding-top: 5px
            margin-right: 10px
            .description-box
                background-color: white
                padding: 10px
                margin-top: 6px
                margin-bottom: 20px
                m-font-size(12,14)
                color: $cloud-burst
                border-radius: 5px
                box-shadow: 5px 5px 20px rgba($lynch, 0.25)
                display: flex
                flex-direction: row
                .descriptors
                    font-weight: bold
                    margin-right: 20px
        .size-column
            padding-top: 5px
            .size-box
                margin-bottom: 10px
      
      .scenario-container
        display: flex
        flex-direction: row
        .item
          flex: 50%

    .left-block
      display: flex
      flex-direction: column
      flex: 1 0.3 30%
      
      .drug-params
        display: flex
        flex-direction: row
        flex-wrap: wrap

      .drug-dynamic-container
        display: flex
        flex-direction: row
        .item
          flex: 50%
          margin-left: 10px
          
      .plot-container
        margin-left: 15px
        box-shadow 0 0 20px rgba($lynch, 0.25)
        .custom-drug-validation-plot
          background: white
          padding: 20px 20px 5px 20px

        .ion-channels-container
          background: #f0f0f6
          padding: 20px
          .column-parameters
            color: $shuttle-gray
            m-font-size(12, 14)
            display: flex
            flex-direction: column
            justify-content: center

            .parameter-label-ic50
              margin-bottom: 45px

</style>